import Text from "@ingka/text";
import { useLocation } from "react-router";

enum Section {
  IMPORT_FILES = "Import files",
  MANDATORY_METADATA = "Mandatory metadata",
  OPTIONAL_METADATA = "Optional metadata",
  UNDER_REVIEW = "Under review",
}

const adminSections = [Section.MANDATORY_METADATA, Section.OPTIONAL_METADATA];
const userSections = [
  Section.IMPORT_FILES,
  Section.MANDATORY_METADATA,
  Section.OPTIONAL_METADATA,
  Section.UNDER_REVIEW,
];

export const SectionIndicator = () => {
  const { pathname } = useLocation();

  const sections = pathname.startsWith("/admin/")
    ? adminSections
    : userSections;

  const shouldRender =
    pathname === "/" ||
    pathname.includes("/edit/") ||
    (pathname.startsWith("/uploads") && !pathname.endsWith("/comments"));

  return (
    shouldRender && (
      <section className="center my-space300">
        <ul className="flex gap-space200">
          {sections.map((section) => (
            <li
              key={section}
              className={`${section === getCurrentSection(pathname) ? "pb-1 border-b-4 border-b-[#0058A3]" : ""}`}
            >
              <Text headingSize="xs" className="text-center">
                {section}
              </Text>
            </li>
          ))}
        </ul>
      </section>
    )
  );
};

const SECTION_BY_PATTERN: Record<string, Section> = {
  "mandatory-video-metadata": Section.MANDATORY_METADATA,
  "mandatory-document-metadata": Section.MANDATORY_METADATA,
  "mandatory-metadata": Section.MANDATORY_METADATA,
  "optional-metadata": Section.OPTIONAL_METADATA,
  "under-review": Section.UNDER_REVIEW,
};

function getCurrentSection(pathname: string): Section {
  const match = Object.keys(SECTION_BY_PATTERN).find((pattern) =>
    pathname.includes(pattern),
  );
  return match ? SECTION_BY_PATTERN[match] : Section.IMPORT_FILES;
}
